<template>
  <paged-report-panel
    class="generic-tab"
    v-model="pagedFilter"
    :min-search-length="0"
    :total-rows="totalRecords"
    :loading="loading"
    :search-placeholder="$t('reports.asset-relation.search-name-number')"
    :search-term-property="'genericSearch'"
    @input="onRefreshSearch"
  >
    <s-loader
      v-show="loading"
      class="generic-tab__loader"
      size="lg"
    />
    <additional-fields-table
      v-show="!loading"
      class="generic-tab__table"
      :items="items"
      :fields="fields"
      :additional-fields-to-show="additionalFieldsToShow"
    />
  </paged-report-panel>
</template>

<script>
import PagedReportPanel from '@/domain/components/generalPanel/reports/PagedReportPanel';
import assetsRelationsFields from '@/domain/data/generalPanel/reports/assetsRelation/assetsRelationsFields';
import AdditionalFieldsTable from '@/domain/components/generalPanel/reports/additionalFields/AdditionalFieldsTable';
import { additionalFieldsMap } from 'sigma-mappings';

export default {
  name: 'GenericAssetRelationTab',
  components: {
    AdditionalFieldsTable,
    PagedReportPanel,
  },
  props: {
    assetsRelation: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pagedFilter: {
      page: 1,
      pageSize: 15,
    },
  }),
  computed: {
    items() {
      return this.assetsRelation.data || [];
    },
    totalRecords() {
      return this.assetsRelation.total;
    },
    fields() {
      return assetsRelationsFields(this);
    },
    additionalFieldsToShow() {
      const additionalFields = Object.values(additionalFieldsMap);
      return additionalFields.filter(
        field => this.items.some(item => item[field] !== undefined),
      );
    },
  },
  methods: {
    onRefreshSearch(input) {
      this.pagedFilter = input;
      this.refreshData();
    },
    refreshData() {
      this.$emit('refresh-data', this.pagedFilter);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .generic-tab
    &__table
      height: 50vh
      max-height: unset
      +media-min-2xl
        height: 65vh
    &__loader
      height: 55vh
    ::v-deep
      th
        white-space: nowrap
      th:last-child
        text-align: center !important
      td span
        max-width: 350px
        width: max-content
        display: block
        text-align: center
        margin: auto
      td:first-child span
        margin: unset
</style>
